<template>
  <transition name="fade">
    <div v-show="show" class="note">
      <div class="notification cf-notification" :class="levelClass">
        <button @click="close()" class="delete"></button>
        {{ message }}
      </div>
    </div>
  </transition>
</template>

<script>
import store from '../store.js'

export default {
  name: 'Notify',
  methods: {
    close () {
      store.commit('notifyClose')
    },
  },
  data () {
    const sec = 1000
    return {
      duration: 3 * sec,
      timeout: null,
    }
  },
  watch: {
    show (show) {
      // if the notification is sticky, we don't want to trigger an auto clear
      if (this.sticky) return
      // if the notification is begining to show, then create a timeout that
      // will automatically close it.
      if (show) {
        this.timeout = setTimeout(() => this.close(), this.duration)
      } else {
        clearTimeout(this.timeout)
      }
    },
  },
  computed: {
    show () {
      return store.state.notification.show
    },
    message () {
      return store.state.notification.message
    },
    level () {
      return store.state.notification.level
    },
    sticky () {
      return store.state.notification.sticky
    },
    levelClass () {
      return this.level ? 'is-' + this.level : 'is-success'
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
  transform: translateY(0);
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(100px);
}

.note {
  position: fixed;
  z-index: 101;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 1rem 4rem;
  user-select: none;
  cursor: default;
  text-align: center;
}

.cf-notification {
  font-size: 1.5rem;
  padding: 0.75rem 2.5rem 0.75rem 1.5rem;
}
</style>



// WEBPACK FOOTER //
// Notify.vue?aee96bbc